import { DeliveryModel, Journey, journeyToJourneyDetails } from '@audibene/ta.utils-opportunity'
import { Country } from './country'

type TeleaudiologyJourney = {
  [K in keyof typeof journeyToJourneyDetails]: (typeof journeyToJourneyDetails)[K]['deliveryModel'] extends typeof DeliveryModel.TELEAUDIOLOGY
    ? K
    : never
}[keyof typeof journeyToJourneyDetails]

type TALightJourney = {
  [K in keyof typeof journeyToJourneyDetails]: (typeof journeyToJourneyDetails)[K]['deliveryModel'] extends typeof DeliveryModel.TA_LIGHT
    ? K
    : never
}[keyof typeof journeyToJourneyDetails]

type TAOnsiteJourney = {
  [K in keyof typeof journeyToJourneyDetails]: (typeof journeyToJourneyDetails)[K]['deliveryModel'] extends typeof DeliveryModel.TA_ONSITE
    ? K
    : never
}[keyof typeof journeyToJourneyDetails]

type TeleaudiologyOrTALightJourneySet = Omit<Set<TeleaudiologyJourney | TALightJourney | TAOnsiteJourney>, 'has'> & {
  has: (journey: Journey) => boolean
}

const teleaudiologyOrTaLightJourneys = new Set<TeleaudiologyJourney | TALightJourney | TAOnsiteJourney>(
  Object.entries(journeyToJourneyDetails)
    .filter(
      ([, details]) =>
        details.deliveryModel === DeliveryModel.TELEAUDIOLOGY ||
        details.deliveryModel === DeliveryModel.TA_LIGHT ||
        details.deliveryModel === DeliveryModel.TA_ONSITE
    )
    .map(([journey]) => journey as TeleaudiologyJourney | TALightJourney | TAOnsiteJourney)
) as TeleaudiologyOrTALightJourneySet

const isPrsBasedJourney = (journey?: string): boolean => Boolean(journey && teleaudiologyOrTaLightJourneys.has(journey as Journey))

const isShopGidOptionalForPrsFlow = (journey?: string, country?: string): boolean => isPrsBasedJourney(journey) && country === Country.US

export { isPrsBasedJourney, isShopGidOptionalForPrsFlow, teleaudiologyOrTaLightJourneys }
